import React from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Modal } from '@arnsbogroup/react-voicearchive'
import { useIntl } from 'react-intl'
import MemoryDetails from 'components/MemoryDetails'
import messages from './messages'

export default NiceModal.create(({ initialOrderId = null, initialTaskId = null, initialCustomerId = null, initialMemory = null, onSave = null }) => {
  const modal = useModal()
  const { formatMessage } = useIntl()

  const handleSave = () => {
    modal.remove()
    onSave?.()
  }

  return (
    <Modal
      show={modal.visible}
      title={formatMessage(messages.title)}
      onClose={() => modal.remove()}
      dialogPanelClasses="max-w-lg"
    >
      <MemoryDetails
        initialOrderId={initialOrderId}
        initialTaskId={initialTaskId}
        initialCustomerId={initialCustomerId}
        initialMemory={initialMemory}
        onSave={handleSave}
        onClose={() => modal.remove()}
      />
    </Modal>
  )
})
